import { useState, useEffect } from 'react';
import {
    Box,
    Container,
    Grid,
    Pagination,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Typography,
    Slider,
    TextField
} from '@mui/material';
import { fetchAuthors, Author } from '../../api/authorService';
import { AuthorCard } from './AuthorCard';
import { AuthorCardSkeleton } from './AuthorCardSkeleton';

const SORT_OPTIONS = [
    { value: 'popular', label: 'По популярности' },
    // { value: 'name_asc', label: 'По имени (А-Я)' },
    // { value: 'name_desc', label: 'По имени (Я-А)' },
    { value: 'videos', label: 'По количеству видео' },
];

export const AuthorsPage = () => {
    const [followerRange, setFollowerRange] = useState<[number, number]>([0, 1000000]);
    const [authors, setAuthors] = useState<Author[]>([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [sort, setSort] = useState('popular');
    const [loading, setLoading] = useState(true);
    const limit = 12;

    useEffect(() => {
        const loadAuthors = async () => {
            setLoading(true);
            try {
                const { data, total } = await fetchAuthors((page - 1) * limit, limit);

                // Сортируем данные локально (или можно сортировать на сервере)
                // const sortedData = [...data].sort((a, b) => {
                //     switch (sort) {
                //         case 'name_asc': return a.username.localeCompare(b.username);
                //         case 'name_desc': return b.username.localeCompare(a.username);
                //         case 'videos': return b.video_count - a.video_count;
                //         default: return (b.followers || 0) - (a.followers || 0);
                //     }
                // });

                setAuthors(data);
                setTotal(total);
            } finally {
                setLoading(false);
            }
        };

        loadAuthors();
    }, [page, sort]);

    return (
        <Container maxWidth={false} sx={{ py: 4 }}>
            <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h4" component="h1">
                    Все авторы
                </Typography>

                <Box sx={{ width: 250, mr: 2 }}>
                    <Typography gutterBottom>Подписчики</Typography>
                    <Slider
                        value={followerRange}
                        onChange={(_, newValue) => setFollowerRange(newValue as [number, number])}
                        valueLabelDisplay="auto"
                        min={0}
                        max={1000000}
                        step={1000}
                    />
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <TextField
                            size="small"
                            value={followerRange[0]}
                            onChange={(e) => setFollowerRange([+e.target.value, followerRange[1]])}
                        />
                        <TextField
                            size="small"
                            value={followerRange[1]}
                            onChange={(e) => setFollowerRange([followerRange[0], +e.target.value])}
                        />
                    </Box>
                </Box>
                {/* <Box sx={{ minWidth: 250 }}>
                    <FormControl fullWidth>
                        <InputLabel>Сортировка</InputLabel>
                        <Select
                            value={sort}
                            label="Сортировка"
                            onChange={(e) => setSort(e.target.value)}
                        >
                            {SORT_OPTIONS.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box> */}
            </Box>

            {/* Список авторов */}
            {loading ? (
                <Grid container spacing={3}>
                    {Array.from({ length: limit }).map((_, index) => (
                        <Grid sx={{ xs: 12, sm: 3, md: 4, lg: 3 }} key={index}>
                            <AuthorCardSkeleton />
                        </Grid>
                    ))}
                </Grid>
            ) : (
                <Grid container spacing={3}>
                    {authors.map((author) => (
                        <Grid sx={{ xs: 12, sm: 3, md: 4, lg: 3 }} key={author.id}>
                            <AuthorCard author={author} />
                        </Grid>
                    ))}
                </Grid>)}

            {/* Пагинация */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                <Pagination
                    count={Math.ceil(total / limit)}
                    page={page}
                    onChange={(_, value) => setPage(value)}
                    color="primary"
                    size="large"
                />
            </Box>
        </Container>
    );
};